<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>Academic Groups for {{ subject }}</h2>
        <div class="pgectr">
            <span class="pgebtn" @click="createNew">
                Create Group
            </span>
        </div>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Group Name" />
        <PrimeColumn field="students" header="Members" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        v-if="slotProps.data.id.substr(0,5) != 'grade'"
                        label="Edit"
                        icon="pi pi-user-edit"
                        class="p-button-rounded p-button-text"
                        @click="edit(slotProps.data)"
                    />
                    <PrimeButton
                        label="Assignment"
                        icon="pi-file-o"
                        class="p-button-rounded p-button-text"
                        @click="assignment(slotProps.data, 'Fall')"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>

  <ModalView
        :isVisible="state.createModal"
        :fixclose="true"
        @close="state.createModal = false">
        <DynamicForm :columns="2"
            :fields="createFields" @submit="createGroup"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>

  <ModalView
        :isVisible="state.editModal"
        :fixclose="true"
        @close="state.editModal = false">
        <DynamicForm :columns="2"
            :fields="editFields" @submit="updateGroup"
            :submitting="state.submitting" :errors="state.errors"
            :success="state.success" />
    </ModalView>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter, useRoute } from "vue-router";
import ModalView from "@/components/ModalView.vue";
import DynamicForm from "@/components/DynamicForm.vue";

export default {
    name:"AcademicGroups",
    components:{ModalView,DynamicForm},
    setup(){
        const route = useRoute();
        const router = useRouter();
        const sub_id = computed(() => route.params.sub)
        const state=reactive({loading:true,createModal:false,submitting:false,error:[],success:false,
            editModal:false
        })
        const list = ref([])
        const subject=ref("");
        const globalFilter=ref("")
        const students=ref([])
        const subjects=ref([])
        const editFields=ref([]);
        const createFields=ref([
            { name: "Create Group", number: "1",data: 
                [
                    { type: 'text', name: 'name', label: 'Group Name',
                        value:"" },
                ]
            },
            { name: "Assign Students", number: "2",data: 
                [
                    { type: 'checkbox', name: 'students', label: 'Students',
                        value:"",values:students },
                    { type: 'radio', name: 'subjects', label: 'Subjects',
                        value:"",values:subjects },
                ]
            }
        ])
        onMounted(() => {
            call({
                url:urls.subject,
                data:{getAcademicGroups:sub_id.value},
                success:(res)=>{
                state.loading=false
                if(res.status){
                    subject.value=res.msg.subject;
                    if (!Array.isArray(res.msg.data)) {
                        list.value = Object.values(res.msg.data)
                    } else {
                        list.value = res.msg.data
                    }
                    students.value=[];
                    Object.keys(res.msg.stu_list).forEach(k => {
                        students.value.push(res.msg.stu_list[k])
                    })
                    subjects.value=[];
                    Object.keys(res.msg.subs).forEach(k => {
                        subjects.value.push(res.msg.subs[k])
                    })
                }else{
                    alert(res.msg);
                }
                }
            })
        });

        function assignment(row){
            console.log(row.id)
            router.push({ name: 'assignment', params:{group:row.id, sub:sub_id.value}} );
        }

        function edit(row){
            var stuval=row.stu_val.split(",");
            editFields.value=[
                { name: "Edit Group", number: "1",data: 
                    [
                        { type: 'text', name: 'name', label: 'Group Name',
                            value:row.name },
                        { type: 'hidden', name: 'id', value:row.id },
                    ]
                },
                { name: "Assign Students", number: "2",data: 
                    [
                        { type: 'checkbox', name: 'students', label: 'Students',
                            value:stuval,values:students },
                        { type: 'radio', name: 'subjects', label: 'Subjects',
                            value:row.sub_val,values:subjects },
                    ]
                }
            ]
            state.editModal=true;
            state.submitting=false;
            state.errors=[];
            state.success=false;
        }
        
        function createNew(){
            state.createModal=true;
            state.submitting=false;
            state.errors=[];
            state.success=false;
        }

        function createGroup(data){
            state.submitting=true;
            state.errors=[];
            data.createGroup="";
            state.success=false;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        if (!Array.isArray(res.msg.data)) {
                            list.value = Object.values(res.msg.data)
                        } else {
                            list.value = res.msg.data
                        }
                        if(res.msg.error != ""){
                            alert(res.msg.error);
                        }
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }

        function updateGroup(data){
            state.submitting=true;
            state.errors=[];
            data.updateGroup="";
            state.success=false;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.submitting=false;
                    if(res.status){
                        state.success=true;
                        if (!Array.isArray(res.msg.data)) {
                            list.value = Object.values(res.msg.data)
                        } else {
                            list.value = res.msg.data
                        }
                        if(res.msg.error != ""){
                            alert(res.msg.error);
                        }
                    }else{
                        alert(res.msg)
                    }
                }
            })
        }
        
        return {list,globalFilter, state,assignment,subject, createFields, createNew,createGroup,
            editFields,edit,updateGroup
        }
    }
}
</script>